import { Component, ElementRef, HostBinding, Input, OnDestroy, OnInit, Renderer2, ViewChild } from '@angular/core';
import { AbstractControl, UntypedFormControl } from '@angular/forms';
import * as _ from 'lodash';

/**
 * Commponent for the icon picker
 */
@Component({
  selector: '[app-form-field-icon-picker]',
  templateUrl: './form-field-icon-picker.component.html',
  styleUrls: ['./form-field-icon-picker.component.scss'],
})
export class FormFieldIconPickerComponent implements OnInit, OnDestroy {
  @HostBinding('class.esf-form-item') public get formItemClass(): boolean {
    return true;
  }
  @ViewChild('toggleButton') toggleButton: ElementRef;
  @ViewChild('iconPicker') iconPicker: ElementRef;
  @Input() public optional: boolean = false;
  @Input() public label: string = '';
  @Input() public control: AbstractControl;
  @Input() public icons: Array<string> = [];

  public id: string;
  public isOpen: boolean;
  constructor(private renderer: Renderer2) {
    this.renderer.listen('window', 'click', (e: Event) => {
      if (!this.toggleButton.nativeElement.contains(e.target) && e.target !== this.iconPicker.nativeElement) {
        this.isOpen = false;
      }
    });
  }

  get formControl(): UntypedFormControl {
    return this.control as UntypedFormControl;
  }

  get icon(): string {
    return this.control.value;
  }

  public ngOnInit(): void {
    if (!this.icons.length) {
      this.icons.push('whistle', 'trophy', 'soccer-ball', 'sports-fan', 'handshake', 'crown', 'diamond', 'cap', 'award', 'basketball', 'coupon', 'star');
    }
    const parent = this.control.parent;
    for (const key of Object.keys(parent.controls)) {
      const childControl = _.get(parent.controls, key);
      if (childControl === this.control) {
        this.id = key;
      }
    }
  }

  setIcon(val: string) {
    this.control.setValue(val);
  }

  openIconPicker() {
    this.isOpen = !this.isOpen;
    this.iconPicker.nativeElement.scrollIntoView();
  }

  public ngOnDestroy(): void { }
}
